export const isSuccess = (responseStatus: number) => {
  return responseStatus >= 200 && responseStatus < 300;
};
